import type { ReviewImage, ReviewImageRendition } from "./types";

// Local inspection policy for alternatives: thumbnails must not unlock a review.
export const MIN_REVIEW_RENDITION_SIDE = 500;

/** Canonical evidence stays first; alternatives are actual supplied Amazon URLs. */
export function reviewImageSources(image: ReviewImage): ReviewImageRendition[] {
  if (typeof image.url !== "string" || !image.url.trim()) return [];
  const sources: ReviewImageRendition[] = [{ url: image.url,
    ...(image.width !== undefined ? { width: image.width } : {}),
    ...(image.height !== undefined ? { height: image.height } : {}),
  }];
  const seen = new Set([image.url]);
  const alternatives = (Array.isArray(image.renditions) ? image.renditions : []).filter(item =>
    item && typeof item.url === "string" && Boolean(item.url.trim())
    && Number.isInteger(item.width) && Number.isInteger(item.height)
    && item.width! > 0 && item.height! > 0
    && Math.max(item.width!, item.height!) >= MIN_REVIEW_RENDITION_SIDE,
  ).slice().sort((left, right) =>
    right.width! * right.height! - left.width! * left.height!
    || (left.url < right.url ? -1 : left.url > right.url ? 1 : 0),
  );
  for (const source of alternatives) {
    if (seen.has(source.url)) continue;
    seen.add(source.url);
    sources.push({ url: source.url, width: source.width, height: source.height });
  }
  return sources;
}

/** Equal primary URLs alone do not make country-specific fallback evidence equal. */
export function reviewImageSourceKey(image: ReviewImage): string {
  const sources = reviewImageSources(image);
  return JSON.stringify(sources.map((source, index) => index === 0
    ? [source.url] : [source.url, source.width, source.height]));
}
